// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__u5qkM","webHeader":"Header_webHeader__fAefM","homeTitle":"Header_homeTitle__Nvedw","mobileHeader":"Header_mobileHeader__BZPyi"};